export default __webpack_public_path__ + "static/media/user_double.e22344b0.svg";